export const PageHeader = ({ title, subtitle, actions }) => (
  <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between mb-6 animate-fade-in-up">
    <div>
      <h1 className="font-display text-2xl md:text-3xl font-bold text-slate-900" data-testid="page-title">{title}</h1>
      {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);
